import React from 'react';

import NotFound from './NotFound';

const DynamicRouteHandler = () => {
	// If no match or invalid ID, render the NotFound component
	return <NotFound />;
};

export default DynamicRouteHandler;
